export 
const manuelsMatch = {
  "admin-filial":"/assets/media/files/Guide_Admin_Filiale.pdf",
  "pilot-filial":"/assets/media/files/Guide_Pilote_Filiale.pdf",
  "collector-filial":"/assets/media/files/Guide_Collecteur_Filiale.pdf",
  "staff":"/assets/media/files/Guide_Staff.pdf",

  "admin-holding":"/assets/media/files/Guide_Admin_Holding.pdf",
  "pilot-holding":"/assets/media/files/Guide_Pilote_Holding.pdf",
  "collector-holding":"/assets/media/files/Guide_Collecteur_Holding.pdf",

  "admin-fonctionnel":"/assets/media/files/Guide_Admin_Fonctionnel.pdf",
  "admin-technique":"/assets/media/files/Guide_Admin_Technique.pdf",
  "conformite-filiale":"/assets/media/files/Guide_Conformite_Filiale.pdf",
  "conformite-holding":"/assets/media/files/Guide_Conformite_Holding.pdf",
  "profil-consultatif":"/assets/media/files/Guide_Profil_Consultatif.pdf",
};